export default __webpack_public_path__ + "static/media/initialdistribution.b2f8b4de.png";